import { ReferenceDot } from 'recharts';

import { MarkerProps } from './types';
import { useChartContext } from '../../ChartProvider';

export const ChartMarker = <T,>({
  unixDataKey,
  shape: Shape,
  shouldRender,
}: MarkerProps<T>) => {
  const { data } = useChartContext<T>();
  return data
    .map((item, originalIndex) => ({ item, originalIndex }))
    .filter(({ item, originalIndex }) => shouldRender(item, originalIndex))
    .map(({ item, originalIndex }, markerIndex) => {
      const shape =
        typeof Shape === 'function' ? (
          <Shape
            payload={item}
            index={originalIndex}
            markerIndex={markerIndex}
          />
        ) : (
          Shape
        );
      const value = item[unixDataKey as keyof T] as string | number;
      return <ReferenceDot key={value} x={value} y={0} shape={shape} />;
    });
};
